import React, { Component } from 'react';

import ModoPersonalizado from "./ModoPersonalizado";
import ConfiguracionBasica from "./ConfiguracionBasica";

const DetalleConfiguracionPersonalizada = (props) => {
    var isFirefox = typeof InstallTrigger !== 'undefined';
    const divStyleFireFox = {
        marginTop:'-15px'
      };

      const divStyle = {
        marginTop:'0px'
      };

    if (props.tipoConfiguracion == 1) {
        return (
            <div className="row">
                <div className="row row-radio">
                    <div className="left-separator-xs panel panel-view">
                        <div className="container-radio radio-margin panel-view-radio">
                            <input id="tipoConfiguracion" type="radio" name="group11" checked={true} />
                            <label className="lbl-radio label-secondary panel-view-label level-auxiliary">
                                <i className="ti-panel panel-view-icon" />
                                <p style={isFirefox ? divStyleFireFox : divStyle } >Personalizado</p>
                                <span>Administra usuarios, contraseñas, perfiles y permisos de forma independiente.</span>
                            </label>
                        </div>
                    </div>
                </div>

                <div className="col-xs-12 left-separator-xs">
                    <ConfiguracionBasica cantIntentosFallidos={props.cantIntentosFallidos}
                        maxDiasCaducidad={props.maxDiasCaducidad}
                        maxDiasInactividad={props.maxDiasInactividad}
                        minutosPermitidosInactividad={props.minutosPermitidosInactividad}
                        cantidadRepeticiones={props.cantidadRepeticiones}
                        checkboxChangeState={props.checkboxChangeState}
                        textChangeState={props.textChangeState}/>
                </div>

                <div className="left-separator-xs">
                    <ModoPersonalizado alfabetica={props.alfabetica}
                        caracteresEspeciales={props.caracteresEspeciales}
                        caracteresMinimos={props.caracteresMinimos}
                        caseSensitive={props.caseSensitive}
                        numerica={props.numerica}
                        permiteCaracteresIguales={props.permiteCaracteresIguales}
                        permiteLetrasConsecutivas={props.permiteLetrasConsecutivas}
                        permiteNrosConsecutivos={props.permiteNrosConsecutivos}
                        permiteRepetirPosicion={props.permiteRepetirPosicion}
                        plataformas={props.plataformas}
                        checkboxChangeState={props.checkboxChangeState}
                        textChangeState={props.textChangeState}
                        plataformaValueChange={props.plataformaValueChange}
                        radioButtonChangeContrasenia={props.radioButtonChangeContrasenia}/>
                </div>
            </div> );
    }

    else if (props.tipoConfiguracion == 2) {
        return (
            <div className="row">
                <div className="row row-radio">
                    <div className="left-separator-xs panel panel-view">

                        <div className="container-radio radio-margin panel-view-radio">
                            <input id="tipoConfiguracion2" type="radio" name="group11" checked={false} />
                            <label className="lbl-radio label-secondary panel-view-label level-auxiliary" onClick={() => props.configurationTypeChange(props.tipoConfiguracion)}>
                                <i className="ti-panel panel-view-icon" />
                                <p style={isFirefox ? divStyleFireFox : divStyle } >Personalizado</p>
                                <span>Administra usuarios, contraseñas, perfiles y permisos de forma independiente.</span>
                            </label>
                        </div>
                    </div>
                </div> 
            </div> );
    }
};

export default DetalleConfiguracionPersonalizada;